import React, { useEffect, useRef } from "react";
import BackBtn from "../../components/backBtn";
import classNames from "classnames";
import { Player, BigPlayButton, ControlBar, Shortcut } from "video-react";
import LottieRunner from "../../components/LottieRunner";
import * as uploadMsgPopup from "../../resources/lottieFiles/Pop up.json";

import { pages } from "../../constants";
import { getUploadToken } from "../../api";
const Chalenjamoon = ({ state, back }) => {
  console.log("backto", state.backTo);
  const [popupTransition, setPopupTransition] = React.useState(null);
  const [showPopup, setShowPopup] = React.useState(false);
  const [musicEnabled, setMusicEnabled] = React.useState(false);
  const playerRef = useRef(null);
  useEffect(() => {
    if (musicEnabled && playerRef.current) playerRef.current.play();
  }, [musicEnabled]);
  return (
    <div
      className={classNames("chalenjamoon-page", {
        "back-to-home": state.backTo && state.backTo.name === pages.home.name,
      })}
    >
      <BackBtn
        onClick={() => {
          back();
        }}
      />
      <div
        className="thisMusicLink"
        role="button"
        tabIndex="0"
        aria-label="پخش موسیقی چالش"
        onClick={() => {
          setMusicEnabled(true);
        }}
      ></div>
      <div style={{ opacity: 0, width: 0, height: 0 }}>
        {musicEnabled && (
          <Player
            playsInline
            ref={playerRef}
            src={"https://www.hochmuth.com/mp3/Haydn_Cello_Concerto_D-1.mp3"}
          >
            <ControlBar disabled />
            <BigPlayButton disabled />
            <Shortcut clickable={false} />
          </Player>
        )}
      </div>
      <div className={classNames("popupMsg", { hide: !showPopup })}>
        <LottieRunner
          setState={state => {
            // this.setState(state);
          }}
          animationData={uploadMsgPopup}
          transition={popupTransition}
          clearTransition={() => {
            setPopupTransition(null);
          }}
        />
        <div
          className="confirmBtn"
          onClick={() => {
            setShowPopup(false);
          }}
        ></div>
      </div>

      <div
        className="participantInChallengeBtn"
        role="button"
        tabIndex="0"
        aria-label="شرکت در چالش"
        onClick={async () => {
          try {
            const uploadToken = await getUploadToken();
            console.log("uploadToken", uploadToken);
            if (typeof androidApp === "undefined") {
              //in browser
              window.open(
                `https://generaluploader.zharfabeen.com/${uploadToken}`,
                "_blank"
              );
            } else {
              // in rubika
              setShowPopup(true);
              setPopupTransition({ from: 0, to: 225 });
            }
          } catch (error) {
            console.error(error);
          }
        }}
      ></div>
    </div>
  );
};

export default Chalenjamoon;
